import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Reveal";

const FAQS = [
    {
        q: "Are you available 24/7?",
        a: "Yes, we provide 24/7 locksmith availability for emergency situations.",
    },
    {
        q: "Do you provide automotive locksmith services?",
        a: "Yes. We provide automotive locksmith services including vehicle lockouts, key replacement, and programming where supported.",
    },
    {
        q: "Do you work with businesses?",
        a: "Yes. We provide commercial locksmith services for businesses and commercial properties.",
    },
    {
        q: "Can you replace or repair locks?",
        a: "Yes. Depending on the situation, we can repair, replace, rekey, or install locks.",
    },
    {
        q: "How much does a locksmith cost?",
        a: "Pricing depends on the type of service, vehicle or property, time, parts, and complexity of the job. Whenever possible, we provide clear pricing information before beginning the work.",
    },
    {
        q: "How quickly can you arrive?",
        a: "Response time depends on your location, traffic, current calls, and availability. When you call, we'll give you a realistic estimate rather than promising an arrival time we can't guarantee.",
    },
];

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="bg-slate-50 py-20 sm:py-24 lg:py-28">
        <div className="mx-auto w-full max-w-3xl px-5 sm:px-8">
            <SectionHead
                eyebrow="Good to Know"
                title="Frequently Asked Questions"
                testId="faq-heading"
            />
            <Reveal delay={0.15}>
                <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={f.q}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i + 1}`}
                            className="border-slate-200"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i + 1}`}
                                className="py-5 text-left font-display text-lg font-semibold text-slate-900 hover:text-gold-dark hover:no-underline"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-base leading-relaxed text-slate-600">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
